import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, OnInit, signal } from '@angular/core';
import { BagHistoryApiService } from './_api/bag-history.api.service';
import { BagHistory } from './bag-history.model';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { BagHistoryService } from './bag-history.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-bag-history',
	standalone: true,
	imports: [MatCardModule, MatButtonModule, MatTableModule, DatePipe],
	templateUrl: './bag-history.component.html',
	styleUrl: './bag-history.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BagHistoryComponent implements OnInit {
	readonly requestUrl = input.required<string>();
	readonly historyData = signal<BagHistory[]>([]);

	readonly displayedColumns: string[] = ['field', 'old', 'arrow', 'new'];

	private readonly apiService = inject(BagHistoryApiService);
	private readonly bagHistoryService = inject(BagHistoryService);
	private readonly destroyRef = inject(DestroyRef);

	ngOnInit(): void {
		this.bagHistoryService.triggerFetchHistory$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
			this.fetchHistory();
		});
	}

	private fetchHistory(): void {
		this.apiService.getHistory(this.requestUrl()).subscribe((history) => {
			this.historyData.set(history);
		});
	}
}
